/* Do not edit this file. */
/* Any state information should be in /store/app.js */

import { createStore } from "vuex";

import app from "@/store/app";
import auth from "@/store/auth";
import env from "@/store/env";
import datastore from "@/store/datastore";
import groups from "@/store/groups";
import content from "@/store/content"; // Import the content for achievements/questions
import achievements from "@/store/achievements";

const store = createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    auth,
    env,
    datastore,
    groups,
    content,
    achievements
  }
});

export default store;
